import { apiPostAuth, apiGetAuth, apiDeleteAuth } from '@/utils/api'
import { API_NOTIFICATION_PAYMENT } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  notification_payment_list: {
    isLoading: false,
    data: {}
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  }
}

const mutations = {
  "SET_NOTIFICATION_PAYMENT_LIST": (state, payload) => {
    state.notification_payment_list = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  }
}

const actions = {
  async getNotificationPaymentList(context, payload) {
    try {
      context.commit('SET_NOTIFICATION_PAYMENT_LIST', { isLoading: true })
      const response = await apiGetAuth(API_NOTIFICATION_PAYMENT.LIST, payload)
      context.commit('SET_NOTIFICATION_PAYMENT_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_NOTIFICATION_PAYMENT_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async createNotificationPayment(context, payload) {
    try {
      const response = await apiPostAuth(API_NOTIFICATION_PAYMENT.CREATE_NOTIFICATION, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async deleteNotificationPayment(context, payload) {
    try {
      const response = await apiDeleteAuth(API_NOTIFICATION_PAYMENT.BY_ID(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_notification_payment_list: state => {
    return state.notification_payment_list
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
